import { FC } from "react";
import { EFieldTypes, TFunctionFieldProps } from "@middleware/types";
import Field from "@components/ui/Forms/Field/Field";
import { Button } from "@components/ui";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "next-i18next";
import filters from "../filtersList";
import style from "./FiltersForm.module.scss";

interface Props {
  toggle: (codes: string[]) => void;
  selectedFilters: Set<string>;
  isOptimum?: boolean;
}

export const FiltersForm: FC<Props> = ({
  toggle,
  selectedFilters,
  isOptimum = false,
}) => {
  const { t } = useTranslation();
  const defaultValues = filters.reduce(
    (result: Record<string, boolean>, filter) => {
      const { name } = filter;
      result[name] = selectedFilters.has(name) ? true : false;

      return result;
    },
    {},
  );

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    control,
  } = useForm({
    defaultValues: defaultValues as FieldValues,
  });

  const getFieldProps = ({ field }: TFunctionFieldProps) => {
    const fieldProps = {
      name: field.name,
      label: field.label,
      className: field.class,
      register: register,
      control: control,
      defaultValue: field.defaultValue!,
      type: EFieldTypes.CHECKBOX,
      class: "input-checkbox",
    };

    return fieldProps;
  };

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    const values = Object.keys(data).filter((key) => data[key] === true);
    toggle(values);
  };

  return (
    <form
      className={style.wrapForm}
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className={style.form}>
        <ul>
          {filters.map((field, index) => {
            const fieldProps = getFieldProps({
              field,
              register,
              errors: {},
              control,
            });

            return (
              <li className={style.formField} key={index}>
                <Field variant={fieldProps.type} props={fieldProps} />
              </li>
            );
          })}
        </ul>
      </div>
      <div>
        <div className={style.actions}>
          <Button variant="default" disabled={isSubmitting}>
            {t("programs.save")}
          </Button>
        </div>
        {isOptimum && (
          <div className={style.message}>
            {t("message.filterMessageToSaveConfigs")}
          </div>
        )}
      </div>
    </form>
  );
};
